module.exports = __webpack_public_path__ + "static/img/404.236147b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/404.png
// module id = 523
// module chunks = 3